
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 0c3.453 0 6.25 2.237 6.25 5S10.453 10 7 10a7.403 7.403 0 01-3.344-.781C3 9.616 2.09 10 .99 10a.235.235 0 01-.219-.15.256.256 0 01.045-.272c.01-.01.673-.76 1.076-1.703C1.174 7.059.75 6.072.75 5 .75 2.237 3.547 0 7 0zm2.28 2.604L5.818 6.21 4.724 5.054a.552.552 0 00-.8.76l1.512 1.595a.53.53 0 00.767.002l3.872-4.044a.551.551 0 00-.796-.763z","fill":"#fff"}})])
          )
        }
      }
    